import { Routes, Route, Navigate } from 'react-router-dom'

import MarketplaceOrderListView from 'Presentation/Views/Marketplace/List/View'
import MarketplaceOrderDetailView from 'Presentation/Views/Marketplace/Detail/View'
import MarketplaceCouponListView from 'Presentation/Views/Marketplace/Coupon/List/View'
import MarketplaceCouponFormView from 'Presentation/Views/Marketplace/Coupon/Form/View'

const MarketplaceRoutes = () => (
	<Routes>
		<Route path="orders" element={<MarketplaceOrderListView />} />
		<Route path="detail/:uuId" element={<MarketplaceOrderDetailView />} />

		<Route path="coupons" element={<MarketplaceCouponListView />} />
		<Route path="coupons/create" element={<MarketplaceCouponFormView />} />
		<Route path="coupons/:uuId" element={<MarketplaceCouponFormView />} />

		<Route index element={<Navigate to="/marketplace/orders" />} />
		<Route path="*" element={<Navigate to="/marketplace/orders" />} />
	</Routes>
)

export default MarketplaceRoutes
